export const PHONE_SERIES = [
  {
    id: "iphone",
    brand: "iPhone",
    brandKey: "apple",
    icon: "/phones/iphone.png",
    images: ["/phones/iphone.png", "/phones/iphone16.webp"],
    glow: "rgba(46,107,230,0.45)",
    groups: [
      {
        nameKey: "buy.iphoneLine",
        models: [
          "iPhone 5", "iPhone 5s", "iPhone 6", "iPhone 6s", "iPhone 7", "iPhone 8",
          "iPhone X", "iPhone XR", "iPhone XS", "iPhone 11", "iPhone 11 Pro",
          "iPhone 12", "iPhone 12 Pro", "iPhone 13", "iPhone 13 Pro",
          "iPhone 14", "iPhone 14 Pro", "iPhone 15", "iPhone 15 Pro",
          "iPhone 16", "iPhone 16 Pro", "iPhone 17", "iPhone 17 Pro Max",
        ],
      },
    ],
  },
  {
    id: "samsung",
    brand: "Samsung",
    brandKey: "samsung",
    icon: "/phones/samsung.png",
    images: ["/phones/samsung.png", "/phones/a55.webp"],
    glow: "rgba(139,92,255,0.45)",
    groups: [
      {
        name: "S Series",
        models: [
          "S20", "S20+", "S20 Ultra", "S21", "S21+", "S21 Ultra",
          "S22", "S22+", "S22 Ultra", "S23", "S23+", "S23 Ultra",
          "S24", "S24+", "S24 Ultra", "S25", "S25+", "S25 Ultra",
          "S26", "S26+", "S26 Ultra",
        ],
      },
      {
        name: "A Series",
        models: [
          "A12", "A13", "A14", "A15", "A16", "A32", "A33", "A34", "A35",
          "A52", "A53", "A54", "A55", "A71", "A72",
        ],
      },
    ],
  },
  {
    id: "pixel",
    brand: "Google Pixel",
    brandKey: "google",
    icon: "/phones/pixel.png",
    images: ["/phones/pixel.png"],
    glow: "rgba(127,224,195,0.45)",
    groups: [
      {
        nameKey: "buy.pixelLine",
        models: [
          "Pixel 6", "Pixel 6 Pro", "Pixel 6a", "Pixel 7", "Pixel 7 Pro", "Pixel 7a",
          "Pixel 8", "Pixel 8 Pro", "Pixel 8a", "Pixel 9", "Pixel 9 Pro",
          "Pixel 10", "Pixel 10 Pro", "Pixel 11", "Pixel 11 Pro",
        ],
      },
    ],
  },
];
